/**
 * Registru de curățare la încheierea sesiunii (logout, auto-logout, 401).
 *
 * `clearSession` din stores/auth.ts zeroizează cheile, dar date decriptate
 * trăiesc și în afara store-ului: cache-ul TanStack Query, blob URL-uri de
 * imagini, state de editor. Modulele care țin astfel de date își înregistrează
 * aici o funcție de curățare — așa store-ul de auth nu trebuie să le importe
 * (ar crea cicluri) și nimic nu rămâne pentru următorul user din același tab.
 */
type Cleanup = () => void;

const cleanups = new Set<Cleanup>();

export function registerSessionCleanup(fn: Cleanup): void {
  cleanups.add(fn);
}

export function runSessionCleanup(): void {
  for (const fn of cleanups) {
    try {
      fn();
    } catch {
      // o curățare eșuată nu trebuie să le blocheze pe celelalte
    }
  }
}
